(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-product-social-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('social-video-card')) {
    customElements.define(
      'social-video-card',
      class SocialVideoCard extends HTMLElement {
        connectedCallback() {
          if (this.bound) return
          this.bound = true
          this.video = this.querySelector('video')
          this.button = this.querySelector('.social-video-card__toggle')
          if (this.button) {
            this.button.addEventListener('click', () => {
              this.dispatchEvent(new CustomEvent('social-video-toggle', { bubbles: true }))
            })
          }
          if (this.video) {
            this.video.addEventListener('ended', () => {
              this.setPlaying(false)
              this.dispatchEvent(new CustomEvent('social-video-ended', { bubbles: true }))
            })
            this.video.addEventListener('play', () => this.setPlaying(true))
            this.video.addEventListener('pause', () => {
              if (!this.video.ended) this.setPlaying(false)
            })
          }
        }

        get playable() {
          return Boolean(this.video && this.video.dataset.src)
        }

        ensureSrc() {
          if (!this.video || this.video.getAttribute('src') || !this.video.dataset.src) return
          this.video.src = this.video.dataset.src
        }

        play() {
          if (!this.playable) return Promise.resolve()
          this.ensureSrc()
          this.video.muted = true
          this.video.playsInline = true
          if (this.video.ended) this.video.currentTime = 0
          return this.video
            .play()
            .then(() => {
              this.classList.add('is-active')
            })
            .catch(() => {})
        }

        pause() {
          if (!this.video) return
          this.video.pause()
          this.setPlaying(false)
        }

        deactivate() {
          this.pause()
          this.classList.remove('is-active')
        }

        setPlaying(playing) {
          this.classList.toggle('is-playing', playing)
          if (!this.button) return
          this.button.setAttribute('aria-pressed', playing ? 'true' : 'false')
          var label = this.button.getAttribute('aria-label') || ''
          var name = label.replace(/^(Play|Pause)\s+/i, '')
          this.button.setAttribute('aria-label', (playing ? 'Pause ' : 'Play ') + name)
        }
      }
    )
  }

  if (!customElements.get('social-video-rail')) {
    customElements.define(
      'social-video-rail',
      class SocialVideoRail extends HTMLElement {
        connectedCallback() {
          if (this.bound) return
          this.bound = true
          queueMicrotask(() => this.setup())
        }

        setup() {
          this.userPaused = false
          this.currentIndex = 0
          this.cards = Array.from(this.querySelectorAll('social-video-card'))
          this.addEventListener('social-video-toggle', (event) => this.onToggle(event.target))
          this.addEventListener('social-video-ended', (event) => this.onEnded(event.target))
          this.observeStart()
        }

        observeStart() {
          var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)')
          if (reduceMotion.matches) return
          var observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) {
                  this.cards.forEach((card) => card.pause())
                  return
                }
                if (this.userPaused) return
                this.playAt(this.currentIndex)
              })
            },
            { threshold: 0.25 }
          )
          observer.observe(this)
        }

        pauseOthers(except) {
          this.cards.forEach((card) => {
            if (card === except) return
            card.deactivate()
          })
        }

        playAt(index) {
          if (!this.cards.length) return
          var start = ((index % this.cards.length) + this.cards.length) % this.cards.length
          for (var n = 0; n < this.cards.length; n++) {
            var target = (start + n) % this.cards.length
            var card = this.cards[target]
            if (!card.playable) continue
            this.currentIndex = target
            this.pauseOthers(card)
            card.play()
            return
          }
        }

        onToggle(card) {
          if (!card || !card.playable) return
          if (card.video && !card.video.paused) {
            this.userPaused = true
            card.pause()
            return
          }
          this.userPaused = false
          var index = this.cards.indexOf(card)
          if (index >= 0) this.currentIndex = index
          this.pauseOthers(card)
          card.play()
        }

        onEnded(card) {
          if (this.userPaused) return
          var index = this.cards.indexOf(card)
          if (index < 0) return
          this.playAt(index + 1)
        }
      }
    )
  }

  } catch(e) { console.error(e); }
})();
})();
